import { PageHero } from "@/pages/About";

export default function Safeguarding() {
    return (
        <div>
            <PageHero title="Safeguarding & Child Protection" subtitle="Our commitment to dignity and safety" />
            <section className="gsf-section" data-testid="safeguarding-content">
                <div className="gsf-container max-w-3xl space-y-6 text-[color:var(--gsf-body)] leading-relaxed">
                    <p>
                        Global Seed Foundation is committed to protecting the dignity, safety and wellbeing of every
                        person who engages with our programmes — particularly children, vulnerable adults, elderly
                        residents and persons with disabilities.
                    </p>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold mt-8">Our principles</h3>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Do no harm.</li>
                        <li>Respect the dignity of every beneficiary.</li>
                        <li>Handle personal information responsibly.</li>
                        <li>Ensure images and stories are shared only with consent.</li>
                        <li>Provide safe reporting channels for concerns.</li>
                    </ul>
                    <h3 className="font-serif text-xl text-[color:var(--gsf-green-700)] font-semibold">Reporting a concern</h3>
                    <p>
                        If you have a safeguarding concern about any Foundation programme, staff member, volunteer or
                        activity, please write to <a className="underline text-[color:var(--gsf-green-700)]" href="mailto:impact@globalseedzim.org">impact@globalseedzim.org</a>.
                        Concerns are treated confidentially and reviewed responsibly.
                    </p>
                </div>
            </section>
        </div>
    );
}
